<template>
  <div class="container">
    <!-- 菜单导航 -->
    <Menu></Menu>
    <!-- 商业订单 -->
    <div class="ordem">
      <div class="ordem-conter">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部" name="first">
            <div class="ordem-list">
              <div class="ordem-item" v-for="(item,index) in listData" :key="index">
                <div class="ordem-item-con">
                  <div class="ordem-item-cover">
                    <img :src="item.thumb" alt="" />
                  </div>
                  <div class="ordem-item-des">
                    <h3 class="title">{{item.title}}</h3>
                    <h3 class="price">￥{{item.price}}</h3>
                    <div class="ordem-reqs">
                      <div class="ordem-req">
                        <span>风格描述</span>
                        <strong>{{item.introduction}}</strong>
                      </div>
                      <div class="ordem-req">
                        <span>需求数量</span>
                        <strong>1项</strong>
                      </div>
                      <div class="ordem-req">
                        <span>使用范围</span>
                        <strong>商用</strong>
                      </div>
                      <div class="ordem-req">
                        <span>来源</span>
                        <strong>美课官方</strong>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ordem-status">
                  <span class="time">
                   <!-- 发布时间：{{item.create_time}} -->
                  </span>
                  <span class="tag-status" @click="toDetails(item.id)">
                  征集中
                  </span>
                </div>
              </div>
            </div>
            <el-pagination background :page-size="6" layout="prev, pager, next" :total="total"
              @current-change="currentChange" @prev-click="prevClick" @next-click="nextClick"></el-pagination>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 底部链接 -->
    <Footer></Footer>
  </div>
</template>
<script>
  import Menu from '@/components/view/Menu'
  import Footer from '@/components/view/Footer'
  export default {
    name: 'ordem',
    components: {
      Menu,
      Footer
    },
    created() {
      this.getData()
    },
    data() {
      return {
        activeName: 'first',
        listData: [],
        total: 0,
        currentPage: 1
      }
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event)
      },
      currentChange(e) {
        this.currentPage = e
        this.getData()
      },
      prevClick(e) {
        this.currentPage = e
        this.getData()
      },
      nextClick(e) {
        alert(e)
        this.currentPage = e
        this.getData()
      },
      getData() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/Task/listData', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: {
            "limit": 6,
            "page": this.currentPage
          }
        }).then(res => {
          this.listData = res.data.data.data
          this.total = res.data.data.total
          console.log(res.data)
        }).catch(err => {
          console.log(err)
        })
      },
      toDetails(id) {
        this.$router.push({
          path: "/taskdetail",
          query: {
            id: id
          }
        })
      }
    }
  }
</script>
<style scoped>
  .ordem {
    width: 100%;
    height: 100%;
    padding: 50px 0;
    background-color: #f8f8f8;
  }

  .ordem-conter {
    padding-bottom: 25px;
    margin: 0px;
    width: 1200px;
    margin: 0 auto;
  }

  .ordem-list {
    margin: 20px 0;
    padding-bottom: 18px;
    margin-left: -20px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }

  .ordem-item {
    position: relative;
    width: 540px;
    padding: 24px 24px 0;
    margin-bottom: 20px;
    margin-left: 20px;
    background-color: #fff;
    border-radius: 6px;
    -ms-box-shadow: 0 0 5px rgba(0, 0, 0, .05);
    -o-box-shadow: 0 0 5px rgba(0, 0, 0, .05);
    -webkit-box-shadow: 0 0 5px rgb(0 0 0 / 5%);
    box-shadow: 0 0 5px rgb(0 0 0 / 5%);
    /* -webkit-transition: all .2s ease-in-out;
    transition: all .2s ease-in-out;
    -webkit-text-decoration-skip: objects;
    text-decoration-skip: objects; */
    /* -webkit-animation: fadeIn .85s ease;
    animation: fadeIn .85s ease;     */
  }

  .ordem-status {
    padding-top: 12px;
    padding-bottom: 12px;
    border-top: 1px solid #eee;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
  }

  .time {
    font-size: 12px;
    line-height: 24px;
    color: #b1b5b9;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .tag-status {
    width: 64px;
    height: 24px;
    font-size: 12px;
    line-height: 24px;
    color: #fff;
    background-color: #3d9dfa;
    text-align: center;
    border-radius: 20px;
  }

  .ordem-item-con {
    padding-bottom: 10px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }

  .ordem-item-cover {
    width: 102px;
    height: 102px;
    margin-right: 18px;
    border-radius: 12px;
  }

  .ordem-item-cover img {
    width: 100%;
    height: 100%;
    border-radius: 12px;
  }

  .ordem-item-des {
    width: 450px;
  }

  .price,
  .title {
    overflow: hidden;
    white-space: nowrap;
    text-align: left;
    text-overflow: ellipsis;
  }

  .price {
    position: absolute;
    top: 24px;
    right: 24px;
    font-weight: 400;
    color: #f36b61;
  }

  .ordem-reqs {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding-top: 20px;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }

  .ordem-req span {
    display: block;
    margin-bottom: 6px;
    font-size: 14px;
    font-weight: 400;
    line-height: 25px;
    color: #9ba0a3;
    text-align: left;
  }

  .ordem-req strong {
    width: 120px;
    overflow: hidden;
    white-space: nowrap;
    text-align: left;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/components/Task.vue